import { Sparkles } from 'lucide-react';
import type { FishFullContact } from '@Types/fish';
import EnrichedProfileCard, {
  hasEnrichmentContent,
} from '@Components/EnrichedProfileCard';

const AiSummarySlide = ({ summary }: { summary: string }) => (
  <div className="flex items-start gap-3 rounded-xl border border-aoh-border bg-aoh-accent-tint p-4 dark:rounded-lg dark:border-blue-900/60 dark:bg-blue-950/20 dark:shadow-sm">
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-aoh-accent text-white dark:rounded-md dark:bg-blue-500 dark:shadow-sm">
      <Sparkles className="h-4 w-4" />
    </div>
    <div className="flex flex-col gap-0.5">
      <span className="text-[11px] font-bold tracking-wider text-aoh-accent uppercase dark:text-[10px] dark:text-blue-300">
        AI Summary
      </span>
      <p className="text-sm leading-relaxed text-aoh-ink italic dark:text-zinc-200">
        "{summary}"
      </p>
    </div>
  </div>
);

type ProfileInsightsProps = {
  aiSummary?: string | null;
  fullContact?: FishFullContact | null;
};

/**
 * A fish's derived insights. The AI summary and the FullContact enrichment are
 * each rendered when they have content, so a fish with neither shows nothing.
 */
const ProfileInsights = ({ aiSummary, fullContact }: ProfileInsightsProps) => {
  const showEnrichment = hasEnrichmentContent(fullContact);

  if (!aiSummary && !showEnrichment) return null;

  return (
    <div className="mb-4 flex flex-col gap-3">
      {aiSummary && <AiSummarySlide summary={aiSummary} />}
      {showEnrichment && (
        <EnrichedProfileCard data={fullContact as FishFullContact} />
      )}
    </div>
  );
};

export default ProfileInsights;
